import * as Yup from "yup";


export const PatientSchema = Yup.object({
    name: Yup.string().required(" Enter Patient Name"),
    phone: Yup.string().min(10, 'Must be exactly 10 digits').required("Enter Mobile Number").matches(/^(((0|((\+)?91(\-)?))|((\((\+)?91\)(\-)?)))?[6-9]\d{9})?$/, "Invalid Number"),
    gender: Yup.string().required(" Select Gender"),
    email: Yup.string().required("Email Is Required"),
    age: Yup.number().required('Age is required'),
    status: Yup.string().required(" Select Status"),
});